import { authDomain, authStore } from '@auth';
import { useMutation } from '@tanstack/react-query';
import dayjs from 'dayjs';
import { useSetRecoilState } from 'recoil';

export const useConfirmCode = () => {
  const setCodeSentAt = useSetRecoilState(authStore.codeSentAtSelector);

  return useMutation(
    (payload: authDomain.ConfirmCodeDto) => {
      return authDomain.authService.confirmCode(payload);
    },
    {
      onSuccess: () => {
        setCodeSentAt(dayjs().toISOString());
      },
    },
  );
};
